import produce from 'immer';

import {
  ADD_ATTACHMENTS_FAILURE,
  ADD_ATTACHMENTS_SUCCESS,
  ADD_CASE_NOTE_SUCCESS,
  ADD_FINE_SUCCESS,
  ADD_FORCED_ABATEMENT_ACTIVITY_FAILURE,
  ADD_FORCED_ABATEMENT_ACTIVITY_SUCCESS,
  ADD_LATE_FEE_SUCCESS,
  ADD_NEW_VIOLATIONS_SUCCESS,
  ADD_PAYMENT_SUCCESS,
  ADD_TIME_LOG_SUCCESS,
  CASE_CONTACT_ADD_FAILURE,
  CASE_CONTACT_ADD_SUCCESS,
  CASE_CONTACT_DELETE_FAILURE,
  CASE_CONTACT_EDIT,
  CASE_CONTACT_EDIT_FAILURE,
  CASE_CONTACT_EDIT_SUCCESS,
  CASE_CREATE_SUCCESS,
  CASE_FETCH_FAILURE,
  CASE_FETCH_SUCCESS,
  CASE_LIST_CLEAR,
  CASE_LIST_FETCH_FAILURE,
  CASE_LIST_FETCH_REQUEST,
  CASE_LIST_FETCH_SUCCESS,
  CASE_LOCATION_EDIT_FAILURE,
  CASE_LOCATION_EDIT_SUCCESS,
  CLEAR_CASE,
  CLOSE_CASE_FAILURE,
  CLOSE_CASE_SUCCESS,
  CREATE_AND_LINK_CASE,
  DELETE_AND_REISSUE_DRAFT_NOTICE_FAILURE,
  DELETE_AND_REISSUE_DRAFT_NOTICE_SUCCESS,
  DELETE_AND_REISSUE_NOTICE_FAILURE,
  DELETE_AND_REISSUE_NOTICE_SUCCESS,
  DELETE_ATTACHMENT_FAILURE,
  DELETE_CASE_LINK_SUCCESS,
  DELETE_FORCED_ABATEMENT_ACTIVITY_FAILURE,
  DELETE_FORCED_ABATEMENT_ACTIVITY_SUCCESS,
  DELETE_NOTICE_FAILURE,
  DELETE_NOTICE_SUCCESS,
  DISMISS_FORCED_ABATEMENT_TRIGGER_FAILURE,
  DISMISS_FORCED_ABATEMENT_TRIGGER_SUCCESS,
  EDIT_CASE_ASSIGNEES_FAILURE,
  EDIT_CASE_ASSIGNEES_SUCCESS,
  EDIT_CASE_CONTACT_LOCATION_UNIT_SUCCESS,
  EDIT_CASE_ENTITY_FAILURE,
  EDIT_CASE_ENTITY_SUCCESS,
  EDIT_CASE_INITIATION_TYPE_SUCCESS,
  EDIT_CASE_NOTE_SUCCESS,
  EDIT_CASE_SECTION_FAILURE,
  EDIT_CASE_SECTION_SUCCESS,
  EDIT_CASE_VIOLATION_DISPOSITION_FAILURE,
  EDIT_CASE_VIOLATION_DISPOSITION_SUCCESS,
  EDIT_CASE_VIOLATION_LOCATION_UNITS_FAILURE,
  EDIT_CASE_VIOLATION_LOCATION_UNITS_SUCCESS,
  EDIT_DOCUMENT_SUCCESS,
  EDIT_FORCED_ABATEMENT_ACTIVITY_FAILURE,
  EDIT_FORCED_ABATEMENT_ACTIVITY_SUCCESS,
  EDIT_FORCED_ABATEMENT_NOTE_FAILURE,
  EDIT_FORCED_ABATEMENT_NOTE_SUCCESS,
  EDIT_INSPECTION_NOTE_FAILURE,
  EDIT_INSPECTION_NOTE_SUCCESS,
  EDIT_NOTICE_DETAILS_FAILURE,
  EDIT_NOTICE_DETAILS_SUCCESS,
  EDIT_SCHEDULED_INSPECTION_FAILURE,
  EDIT_SCHEDULED_INSPECTION_SUCCESS,
  ENTER_DRAFT_MODE,
  EXIT_DRAFT_MODE,
  FETCH_CASE_COLLECTION_STATUS_FAILURE,
  FETCH_CASE_COLLECTION_STATUS_SUCCESS,
  FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_SUCCESS,
  FETCH_LOCATION_CUSTOM_FIELD_VALUES_SUCCESS,
  FLAG_HISTORY_FETCH_FAILURE,
  FLAG_HISTORY_FETCH_SUCCESS,
  GENERATE_DRAFT_NOTICE_FAILURE,
  GENERATE_DRAFT_NOTICE_SUCCESS,
  GET_ALL_ABATEMENT_STAGES_FAILURE,
  GET_ALL_ABATEMENT_STAGES_SUCCESS,
  GET_ATTACHMENT_FAILURE,
  GET_ATTACHMENT_SUCCESS,
  GET_CASE_HISTORY_SUCCESS,
  GET_CASES_COUNT_BY_DRAFT_LOCATION_SUCCESS,
  GET_CASES_COUNT_BY_LOCATION_CCP_SUCCESS,
  GET_CASES_COUNT_BY_LOCATION_SUCCESS,
  GET_EXTERNAL_CASE_SOURCES_FAILURE,
  GET_EXTERNAL_CASE_SOURCES_SUCCESS,
  GET_FINE_PAYEMNT_SUCCESS,
  GET_PRIVATE_CE_DATA_SUCCESS,
  GET_SCHEDULED_LATE_FEE_SUCCESS,
  GET_TIME_LOG_HISTORY_SUCCESS,
  GROUP_ACTION_FAILURE,
  GROUP_ACTION_SUCCESS,
  INITIATE_FORCED_ABATEMENT_FAILURE,
  INITIATE_FORCED_ABATEMENT_SUCCESS,
  ISSUE_CASE_NOTICE_SUCCESS,
  LOAD_MORE_LOCATION_CUSTOM_FIELD_VALUES,
  LOCATION_UPDATE,
  MODIFY_DATES_FAILURE,
  PERFORM_INSPECTION_FAILURE,
  PERFORM_INSPECTION_SUCCESS,
  REOPEN_CASE_FAILURE,
  REOPEN_CASE_SUCCESS,
  SCHEDULE_INSPECTION_FAILURE,
  SCHEDULE_INSPECTION_SUCCESS,
  SEND_XERCE_EMAIL_SUCCESS,
  SET_CREATE_CASE_ACTION,
  SET_DUE_DATE,
  SET_OUTSTANDING_BALANCE,
  SET_TOTAL_LOGGED_HOURS,
  UPDATE_ATTACHMENTS_FAILURE,
  UPDATE_ATTACHMENTS_SUCCESS,
  UPDATE_CASE_COLLECTION_STATUS_FAILURE,
  UPDATE_CASE_EMAIL_READ_STATUS_FAILURE,
  UPDATE_CASE_EMAIL_READ_STATUS_SUCCESS,
  UPDATE_FINE_BILL_TO_CONTACT_FAILURE,
  UPDATE_FINE_BILL_TO_CONTACT_SUCCESS,
  UPDATE_TIME_LOG,
  VALIDATE_CASE_CONFIG_FAILURE,
  VALIDATE_CASE_CONFIG_SUCCESS,
  VOID_WAIVE_TRANSACTION_SUCCESS,
} from '@actions/xerceCase';

import { getUserProfile } from '@utils/AuthUtil';

const initialState: ICreateCaseStore = {
  caseLocation: null,
  abatementStages: null,
  externalCaseSources: null,
  isCaseReadOnly: false,
  hasOverwritePermission: false,
  case: null,
  caseList: null,
  error: null,
  createCaseAction: null,
  isFetching: false,
  xerceCaseHistory: {
    caseHistory: [],
    contactHistory: [],
  },
  timeLogHistory: [],
  isEditMode: false,
  associatedCases: null,
  feeDetails: {
    finesAndPayments: { count: 0, data: [] },
    isNewPaymentFlow: false,
  },
  scheduledLateFeeDetails: { count: 0, data: [] },
  linkedCS: null,
  locationCustomFields: [],
  messages: [],
  groupActionResponse: {
    message: '',
  },
  collectionsHistory: null,
};

export default (state: ICreateCaseStore = initialState, action: any) =>
  produce(state, (draftState: ICreateCaseStore = initialState) => {
    switch (action.type) {
      case VALIDATE_CASE_CONFIG_SUCCESS:
        draftState.error = null;

        return;

      case LOCATION_UPDATE:
        draftState.caseLocation = action.payload;

        return;

      case PERFORM_INSPECTION_SUCCESS:
      case CLOSE_CASE_SUCCESS:
      case CASE_CREATE_SUCCESS:
      case CASE_FETCH_SUCCESS:
      case INITIATE_FORCED_ABATEMENT_SUCCESS:
      case UPDATE_CASE_EMAIL_READ_STATUS_SUCCESS:
      case DELETE_AND_REISSUE_DRAFT_NOTICE_SUCCESS:
      case DELETE_AND_REISSUE_NOTICE_SUCCESS:
      case ISSUE_CASE_NOTICE_SUCCESS:
      case DELETE_NOTICE_SUCCESS:
      case GENERATE_DRAFT_NOTICE_SUCCESS:
        const xerceCase = action.response;
        draftState.case = xerceCase;
        draftState.error = null;

        const { caseViolations } = xerceCase;
        const violationTypeIds = caseViolations
          ? caseViolations.map((violationEntity) => violationEntity.configViolation.configViolationType.id)
          : [];
        const uniqueViolationTypeIds = violationTypeIds.filter(
          (violationTypeId, index) => violationTypeIds.indexOf(violationTypeId) === index
        );
        const userProfile: IUserProfile = getUserProfile();
        const violationTypeScope = userProfile.scopes.xerce.violationTypeScope;

        let isEditable = false;
        for (const violationTypeId in violationTypeScope) {
          if (
            violationTypeScope.hasOwnProperty(violationTypeId) &&
            (violationTypeScope[violationTypeId].violationTypeAccess === ViolationTypeAccess.BASIC ||
              violationTypeScope[violationTypeId].violationTypeAccess === ViolationTypeAccess.OVERWRITE)
          ) {
            isEditable = true;
          }
        }

        draftState.isCaseReadOnly = !uniqueViolationTypeIds.reduce(
          (canEdit, violationTypeId) =>
            canEdit &&
            (violationTypeScope[violationTypeId].violationTypeAccess === ViolationTypeAccess.BASIC ||
              violationTypeScope[violationTypeId].violationTypeAccess === ViolationTypeAccess.OVERWRITE),
          isEditable
        );

        draftState.hasOverwritePermission = uniqueViolationTypeIds.length
          ? uniqueViolationTypeIds.every(
              (violationTypeId) =>
                violationTypeScope[violationTypeId] &&
                violationTypeScope[violationTypeId].violationTypeAccess === ViolationTypeAccess.OVERWRITE
            )
          : false;

        return;

      case GET_PRIVATE_CE_DATA_SUCCESS:
        const data = action.response;
        draftState.case = data;
        draftState.error = null;

        return;

      case CASE_LOCATION_EDIT_SUCCESS:
        const location = action.response;
        draftState.case.location = location;
        draftState.error = null;

        return;

      case FLAG_HISTORY_FETCH_SUCCESS:
        // for case details
        if (draftState.case && draftState.case.location) {
          draftState.case.location.flagHistory = action.response;
        }

        return;

      case EDIT_CASE_ASSIGNEES_SUCCESS:
        const caseAssignee: ICaseUserResponse = action.response;
        draftState.case.caseSummary.caseAssignee = caseAssignee;
        draftState.error = null;

        return;

      case EDIT_CASE_INITIATION_TYPE_SUCCESS:
        const initiationType: string = action.response.initiationType;
        draftState.case.initiationType = initiationType;
        draftState.error = null;

        return;

      case EDIT_CASE_ENTITY_SUCCESS:
        draftState.case.caseViolations = action.response;

        return;

      case EDIT_CASE_VIOLATION_LOCATION_UNITS_SUCCESS:
        draftState.case.caseViolations = action.response;

        return;

      case ADD_NEW_VIOLATIONS_SUCCESS:
        draftState.case.caseViolations = action.response;

        return;

      case ADD_ATTACHMENTS_SUCCESS:
      case GET_ATTACHMENT_SUCCESS:
      case UPDATE_ATTACHMENTS_SUCCESS:
        draftState.case.attachments = action.response;

        return;

      case SEND_XERCE_EMAIL_SUCCESS:
        draftState.case.messages = action.response;

        return;

      case ADD_CASE_NOTE_SUCCESS:
      case EDIT_CASE_NOTE_SUCCESS:
        draftState.case.caseNotes = action.response;

        return;

      case GROUP_ACTION_SUCCESS:
        draftState.groupActionResponse = action.response;

        return;

      case CASE_CONTACT_ADD_FAILURE:
      case CASE_CONTACT_DELETE_FAILURE:
      case PERFORM_INSPECTION_FAILURE:
      case CLOSE_CASE_FAILURE:
      case CASE_FETCH_FAILURE:
      case CASE_LOCATION_EDIT_FAILURE:
      case FLAG_HISTORY_FETCH_FAILURE:
      case VALIDATE_CASE_CONFIG_FAILURE:
      case EDIT_CASE_ASSIGNEES_FAILURE:
      case EDIT_CASE_ENTITY_FAILURE:
      case EDIT_CASE_VIOLATION_LOCATION_UNITS_FAILURE:
      case ADD_ATTACHMENTS_FAILURE:
      case GET_ATTACHMENT_FAILURE:
      case UPDATE_ATTACHMENTS_FAILURE:
      case DELETE_ATTACHMENT_FAILURE:
      case CASE_CONTACT_EDIT_FAILURE:
      case CASE_LIST_FETCH_FAILURE:
      case EDIT_NOTICE_DETAILS_FAILURE:
      case EDIT_SCHEDULED_INSPECTION_FAILURE:
      case SCHEDULE_INSPECTION_FAILURE:
      case GET_ALL_ABATEMENT_STAGES_FAILURE:
      case REOPEN_CASE_FAILURE:
      case EDIT_INSPECTION_NOTE_FAILURE:
      case EDIT_CASE_VIOLATION_DISPOSITION_FAILURE:
      case MODIFY_DATES_FAILURE:
      case INITIATE_FORCED_ABATEMENT_FAILURE:
      case EDIT_FORCED_ABATEMENT_NOTE_FAILURE:
      case ADD_FORCED_ABATEMENT_ACTIVITY_FAILURE:
      case DELETE_FORCED_ABATEMENT_ACTIVITY_FAILURE:
      case EDIT_FORCED_ABATEMENT_ACTIVITY_FAILURE:
      case UPDATE_CASE_EMAIL_READ_STATUS_FAILURE:
      case GROUP_ACTION_FAILURE:
      case DELETE_AND_REISSUE_NOTICE_FAILURE:
      case DELETE_AND_REISSUE_DRAFT_NOTICE_FAILURE:
      case DELETE_NOTICE_FAILURE:
      case GENERATE_DRAFT_NOTICE_FAILURE:
      case UPDATE_CASE_COLLECTION_STATUS_FAILURE:
      case FETCH_CASE_COLLECTION_STATUS_FAILURE:
      case UPDATE_FINE_BILL_TO_CONTACT_FAILURE:
        draftState.error = action.error;
        draftState.isFetching = false;

        return;

      case CASE_CONTACT_EDIT_SUCCESS: {
        const updatedContact = action.response;
        draftState.case.caseContacts = updatedContact;
        draftState.error = null;

        return;
      }

      case CASE_CONTACT_EDIT: {
        const prevContacts = draftState.case.caseContacts;
        const contactId = action.contactId;
        const updatedContact = action.payload;

        draftState.case.caseContacts = prevContacts.map((contact) =>
          contact.id === contactId ? { ...contact, ...updatedContact } : contact
        );

        return;
      }

      case EDIT_CASE_SECTION_SUCCESS:
        draftState.case.customCaseFieldValues = action.response;

        return;

      case DISMISS_FORCED_ABATEMENT_TRIGGER_FAILURE:
      case EDIT_CASE_SECTION_FAILURE:
        draftState.error = action.error;

        return;

      case CASE_LIST_FETCH_REQUEST:
        draftState.isFetching = true;

        return;

      case CASE_LIST_FETCH_SUCCESS:
        draftState.caseList = action.response;
        draftState.isFetching = false;

        return;

      case CASE_LIST_CLEAR:
        draftState.caseList = null;
        draftState.isFetching = false;

        return;

      case CASE_CONTACT_ADD_SUCCESS:
        draftState.case.caseContacts = action.response;

        return;

      case EDIT_CASE_CONTACT_LOCATION_UNIT_SUCCESS:
        draftState.case.caseContacts = action.response;

        return;

      case EDIT_DOCUMENT_SUCCESS:
        draftState.case.forcedAbatement = action.response;

        return;

      case CLEAR_CASE:
        draftState.case = null;

        return;

      case EDIT_NOTICE_DETAILS_SUCCESS:
        const { inspectionId, notice } = action.response;
        draftState.case.inspections.forEach((inspection) => {
          if (inspection.id === inspectionId) {
            inspection.notice = notice;
          }
        });

        return;

      case EDIT_SCHEDULED_INSPECTION_SUCCESS:
        const updatedInspection = action.response;
        // Patch the edited inspection by id so the timeline reflects the change even when it is
        // not the last entry (e.g. once draft-notice inspections exist). Fall back to the last
        // index if the id is somehow absent.
        const updatedIndex = draftState.case.inspections.findIndex(
          (inspection) => inspection.id === updatedInspection.id
        );
        draftState.case.inspections[updatedIndex > -1 ? updatedIndex : draftState.case.inspections.length - 1] =
          updatedInspection;

        return;

      case SCHEDULE_INSPECTION_SUCCESS:
        draftState.case.inspections = action.response;

        return;

      case GET_ALL_ABATEMENT_STAGES_SUCCESS:
        draftState.abatementStages = action.response;

        return;

      case GET_EXTERNAL_CASE_SOURCES_SUCCESS:
        draftState.externalCaseSources = action.response;

        return;

      case GET_EXTERNAL_CASE_SOURCES_FAILURE:
        draftState.externalCaseSources = null;
        draftState.error = action.error;

        return;

      case REOPEN_CASE_SUCCESS:
        draftState.case = action.response;
        draftState.error = null;

        return;

      case SET_CREATE_CASE_ACTION:
        draftState.createCaseAction = action.payload;

        return;

      case EDIT_INSPECTION_NOTE_SUCCESS:
        draftState.case.inspections = action.response;

        return;

      case EDIT_CASE_VIOLATION_DISPOSITION_SUCCESS:
        draftState.case.caseViolations = action.response;

        return;

      case EDIT_FORCED_ABATEMENT_NOTE_SUCCESS:
      case ADD_FORCED_ABATEMENT_ACTIVITY_SUCCESS:
      case DELETE_FORCED_ABATEMENT_ACTIVITY_SUCCESS:
      case EDIT_FORCED_ABATEMENT_ACTIVITY_SUCCESS:
        draftState.case.forcedAbatement = action.response;

        return;
      case ENTER_DRAFT_MODE:
        draftState.isEditMode = true;

        return;

      case EXIT_DRAFT_MODE:
        draftState.isEditMode = false;

        return;

      case DISMISS_FORCED_ABATEMENT_TRIGGER_SUCCESS:
        draftState.case.recommendFAMetadata = action.response;

        return;

      case GET_CASE_HISTORY_SUCCESS:
        draftState.xerceCaseHistory = action.response;

        return;

      case GET_TIME_LOG_HISTORY_SUCCESS:
      case ADD_TIME_LOG_SUCCESS:
        draftState.timeLogHistory = action.response;

        return;

      case ADD_FINE_SUCCESS:
      case ADD_PAYMENT_SUCCESS:
      case ADD_LATE_FEE_SUCCESS:
      case VOID_WAIVE_TRANSACTION_SUCCESS:
      case UPDATE_FINE_BILL_TO_CONTACT_SUCCESS:
        draftState.feeDetails = action.response;

        return;

      case UPDATE_TIME_LOG:
        const prevTimeLogHistory = draftState.timeLogHistory;
        const timeTrackingId = action.timeTrackingId;

        draftState.timeLogHistory = prevTimeLogHistory.filter((timeLog) => timeLog.id !== timeTrackingId);

        const totalHours = draftState.timeLogHistory.reduce((acc, curr) => acc + curr.hours, 0).toFixed(2);

        draftState.case.caseSummary.hoursLogged = parseFloat(totalHours);

        return;

      case SET_TOTAL_LOGGED_HOURS:
        draftState.case.caseSummary.hoursLogged = action.payload;

        return;

      case SET_OUTSTANDING_BALANCE:
        draftState.case.caseSummary.fineDetails.outstandingBalance = action.payload;

        return;

      case SET_DUE_DATE:
        draftState.case.caseSummary.fineDetails.dueDate = action.payload;

        return;

      case GET_CASES_COUNT_BY_LOCATION_SUCCESS:
        draftState.case.location.associatedCases = action.response;

        return;
      case GET_CASES_COUNT_BY_DRAFT_LOCATION_SUCCESS:
        draftState.caseLocation.associatedCases = action.response;

        return;

      case GET_CASES_COUNT_BY_LOCATION_CCP_SUCCESS:
        draftState.associatedCases = action.response;

        return;
      case GET_FINE_PAYEMNT_SUCCESS:
        draftState.feeDetails = action.response;

        return;

      case GET_SCHEDULED_LATE_FEE_SUCCESS:
        draftState.scheduledLateFeeDetails = action.response;

        return;

      case CREATE_AND_LINK_CASE:
        // for variables handled through state
        draftState.linkedCS = action.response;
        /**
         * NOTE: {isEdited} boolean
         * Flag used in case of linked issue is being converted to a code case.
         * Used to check if parcel fields are saved on submission or to be taken
         * from inside the parcel.
         */
        if (action.response.location) {
          const isEdited = action.response.location.isEdited;
          const parcelFieldsValues = isEdited
            ? action.response.location.parcelFields
            : action.response.location.parcel.customFields;
          draftState.caseLocation = {
            ...action.response.location,
            parcelFields: parcelFieldsValues,
          };
        }

        return;

      case DELETE_CASE_LINK_SUCCESS:
        if (draftState.case && draftState.case.caseSummary.linkedIssue) {
          draftState.case.caseSummary.linkedIssue = null;
        }

        return;

      case FETCH_CASE_COLLECTION_STATUS_SUCCESS:
        draftState.collectionsHistory = action.response;

        return;

      case FETCH_LOCATION_CUSTOM_FIELD_VALUES_SUCCESS:
        const resp = action.response;
        let done = false;
        draftState.locationCustomFields.forEach((lcf, ind) => {
          if (lcf && resp && lcf.id && resp.id && lcf.id === resp.id) {
            draftState.locationCustomFields[ind] = resp;
            done = true;
          }
        });
        if (!done && resp && resp.id) {
          draftState.locationCustomFields.push(resp);
        }

        return;

      case FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_SUCCESS:
        draftState.locationCustomFields = action.response;

        return;

      case LOAD_MORE_LOCATION_CUSTOM_FIELD_VALUES:
        draftState.locationCustomFields.forEach((lcf, ind) => {
          if (lcf && action.response && lcf.id && action.response.id && lcf.id === action.response.id) {
            draftState.locationCustomFields[ind].values = [
              ...draftState.locationCustomFields[ind].values,
              ...action.response.values,
            ];
          }
        });

        return;
    }
  });
